import React from "react";
import { findDOMNode } from "react-dom";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import Tree from "./react-virtualized-tree/src";
import baron from "../wea-new-scroll/baron/src/core";
import { traverTree } from "./util";

const Expandable = ({ node, children, onExpand, onSelect }) => {
  const { childs, isLeaf, isopen } = node;
  const hasChildren =
    ("isLeaf" in node && !isLeaf) || (childs && childs.length);
  const className = classNames({
    "ant-tree-icon": true,
    "ant-tree-switcher": true,
    "icon-coms-organization-down": hasChildren && isopen,
    "icon-coms-organization-right": hasChildren && !isopen
  });

  return [
    <i
      onClick={e => {
        hasChildren && onExpand(node, e);
        e.stopPropagation && e.stopPropagation();
        e.preventDefault && e.preventDefault();
        e.nativeEvent && e.nativeEvent.preventDefault();
      }}
      className={className}
    />,
    node.icon && (
      <i
        className={classNames({
          "ant-tree-icon": true,
          [node.icon]: true
        })}
      />
    ),
    <a
      className="ant-tree-node-content-wrapper"
      onClick={e => onSelect(node, e)}
    >
      {children}
    </a>
  ].filter(Boolean);
};

export default class ScrollTree extends React.Component {
  baron = null;
  componentDidMount() {
    const root = findDOMNode(this.root);
    const scrollerParent = findDOMNode(this.scroller);
    const scroller = scrollerParent.querySelector(".scroller");
    const track = findDOMNode(this.track);
    const bar = findDOMNode(this.bar);
    this.baron = baron({
      $: window.jQuery,
      root,
      clipper: root,
      scroller: scroller,
      track: track,
      bar: bar,
      notParentClipper: true
    });
    this.updateData();
  }
  componentWillReceiveProps(nextProps) {
    let update = false;
    if (
      nextProps.expandedKeys != undefined &&
      this.props.expandedKeys != nextProps.expandedKeys
    ) {
      update = true;
    }
    if (
      nextProps.checkedKeys != undefined &&
      this.props.checkedKeys != nextProps.checkedKeys
    ) {
      update = true;
    }
    if (update) {
      this.updateData(nextProps);
    }
  }
  updateData = props => {
    const { datas, itemMainKey, expandedKeys, checkedKeys } =
      props || this.props;
    traverTree(datas, node => {
      const key = node[itemMainKey];
      if (!isEmpty(expandedKeys) && expandedKeys.indexOf(key) !== -1) {
        node.isopen = true;
      } else {
        node.isopen = false;
      }
    });
    this.forceUpdate();
  };
  componentWillUnmount() {
    if (this.baron) {
      this.baron.dispose();
      this.baron = null;
    }
  }
  // get
  getScrollerTrack = () => {
    return (
      <div ref={el => (this.track = el)} className="track">
        <div ref={el => (this.bar = el)} className="bar" />
      </div>
    );
  };
  render() {
    const {
      datas,
      itemMainKey,
      selectedKeys,
      getTitle,
      onExpand,
      onSelect
    } = this.props;
    return (
      <div
        ref={el => (this.root = el)}
        className="wea-tree-baron baron"
        style={{ width: "100%", height: "100%", position: "relative" }}
      >
        <Tree
          nodes={datas}
          className="scroller ant-tree"
          ref={el => (this.scroller = el)}
          nodePaddingLeft={18}
          mainKey={itemMainKey}
        >
          {({ style, node, ...rest }) => {
            // console.log(style, node, ...rest);
            const className = classNames({
              "wea-tree-wrap": true,
              "wea-tree-wrap-true": selectedKeys.some(
                k => k === node[itemMainKey]
              )
            });
            return (
              <div className={className} style={style}>
                <Expandable
                  node={node}
                  {...rest}
                  onExpand={onExpand}
                  onSelect={onSelect}
                >
                  {getTitle(node)}
                </Expandable>
              </div>
            );
          }}
        </Tree>
        {this.getScrollerTrack()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-tree-test/ScrollTree.js